export const landingData = {
    name: 'Loostie',
    title: 'Fullstack Developer | Sysadmin',
    description: 'More about me, and some of my projects',
    quote: 'How do I exit vim?',
    image: 'https://avatars.githubusercontent.com/u/58069159?v=4',
    github: 'https://github.com/Loostie',
    twitter: 'https://twitter.com/lust_dev'
}